
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import RadioButton from '@/components/radio-button.vue';
	import PageFooter from '@/components/page-footer.vue';
	import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import Switch from '@/components/switch.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		supplierList,
		providerresetPassword,
		providerisEncryptExportPhone,
		providerproviderFirstSettlementRateSave,
	} from '@/api/supplier';
	import {
		UserModule
	} from "@/store/modules/user"

	@Component({
		name: 'supplier-list',
		components: {
			RadioButton,
			PageFooter,
			'slz-dialog': Dialog,
			'slz-message': Message,
			'slz-switch': Switch,
			PickerDate
		}
	})
	export default class SupplierList extends Vue {
		private list: any = [];
		private showCheckBox = false;
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private nameKey = '';
		private radioType = 0;
		private radioList: any = [ {
				label: '待审核',
				value: 0
			},{
				label: '已通过',
				value: 1
			}, {
				label: '已驳回',
				value: 2
			}
		];
		private refuseResultVal = 0
		private refuseDetail = ''
		private refuseResult = [{
				label: '商品信息不全',
				value: 0
			}, {
				label: '商品规格不正确',
				value: 1
			}, {
				label: '商品类型违规',
				value: 2
			}
		]
		private showBadHistory = false;
		private currentId = 0;

		private resetpsdShow = false
		private rowmsg:any = {}

		private joint = null
		private jointlist:any = [
			{value:0,label:'未对接'},
			{value:1,label:'已对接-聚水潭'},
			{value:2,label:'已对接-拙燕仓'},
		]

		// private mounted (){
		// 	this.getList();
		// }
		get userId(){
      return Number(UserModule.mallInfo.EmployeeId)
    }
		activated () {
			// console.log(this.userId)
			// console.log(process.env.NODE_ENV)
			this.getList()
		}


		private toBankList(){
			this.$router.push({
				path:'banklist'
			})
		}
		private async savebili(){
			if(!this.rowmsg.FirstSettlementRate){
				this.$message.error('请设置结算比例')
				return
			}
			let two = /^\d+(\.\d{1,2})?$/
			if(this.rowmsg.FirstSettlementRate<1||this.rowmsg.FirstSettlementRate>100||this.rowmsg.FirstSettlementRate!=parseInt(this.rowmsg.FirstSettlementRate)){
				this.$message.error('请输入1-100的数值')
				return
			}
			try{
				let res = await providerproviderFirstSettlementRateSave({
					FirstSettlementRate:Number((this.rowmsg.FirstSettlementRate*100).toFixed(0))/10000,
					ProviderId:this.rowmsg.Id
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				//
			}
		}
		private getrow(row){
			this.rowmsg = JSON.parse(JSON.stringify(row))
		}
		private exportfile(){
			let url = location.origin + '/pc/provider/providerExport'
			url += '?ProviderCheckState=' + this.radioType
			url += '&Keywords=' + encodeURIComponent(this.nameKey)
			url += '&ErpState=' + (this.joint==null?'':this.joint)

			window.open(url)

		}
		private seterp(row){
			this.$router.push({
				path:'seterp',
				query:{
					Id:row.Id
				}
			})
		}
		private async changestate(e,row){
			try{
				let res:any = await providerisEncryptExportPhone({
					Id:row.Id,
					IsEncryptExportPhone:e
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				//
			}
		}
		private async handleConfirm(){
			try{
				let res = await providerresetPassword({
					ProviderId:this.rowmsg.Id
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				//
			}
		}
		private reset(row){
			this.resetpsdShow = true
			this.rowmsg = row
		}
		// 显示违规记录
		private showBad(id: number) {
			this.showBadHistory = true;
			this.currentId = id
		}

		/**
		 * 驳回操作
		 */
		private toRefuse() {
			this.showCheckBox = true;
		}

		/**
		 * 驳回弹窗确认提交
		 */
		private confirm() {
			this.showCheckBox = false;
			console.log('确认提交')
		}

		/**
		 * 驳回弹窗取消
		 */
		private cancel() {
			this.showCheckBox = false;
			console.log('取消提交')
		}

		/**
		 * 跳转到创建页面
		 */
		private toCreate() {
			this.$router.push({
				name: 'Supplier_Detail',
				query: {
					id: '0',
					type: 'new'
				}
			})
		}

		// 搜索
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		// 清空搜索
		private clearSearch() {
			this.nameKey = '';
			this.joint = null
			this.pageNo = 1;
			this.getList()
		}

		// 修改页面
		private changePage(e) {
			this.pageNo = e;
			this.getList();
		}

		//修改radio
		private changRadio() {
			this.pageNo = 1;
			this.getList();
		}

		// 跳转到详情页面
		private toEdit(id: number,type:string) {
			this.$router.push({
				name: 'Supplier_Detail',
				query: {
					id: id + '',
					type: type
				}
			})
		}

		// 获取供应商列表
		private async getList() {
			let params: any = {
				Skip:(this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.nameKey.trim(),
				ProviderCheckState:this.radioType,
				ErpState:this.joint
			}
			// console.log(this.pageNo)
			try {
				const res: any = await supplierList(params);
				this.list = res.Result.Results.map(v=>{
					v.showscale = false
					v.FirstSettlementRate = Number((v.FirstSettlementRate*10000).toFixed(0))/100
					return v
				})
				// console.log(this.list)
				this.total = res.Result.Total;
				if(!this.list.length&&this.pageNo>1){
					this.pageNo-=1
					this.getList()
				}
			} catch (e) {
				console.log('supplierList ===>', e);
			}
		}
	}
